<template>
	<el-dialog
      v-if="visible"
		:visible.sync="visible"
		custom-class="table-dialog"
		:title="titles"
		@close="onClose"
		:center="false"
		:modal-append-to-body="false"
	>
		<div class="contents">
			<el-form
				:model="ruleForm"
				:rules="rules"
				ref="ruleForm"
				:hide-required-asterisk="false"
				label-width="1rem"
			>
				<el-form-item prop="orgId" label="选择区域">
					<el-select v-model="ruleForm.orgId">
						<el-option
							v-for="(item, index) in orgSelects"
							:key="index"
							:label="item.orgName"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="typeId" label="农事类型">
					<el-select v-model="ruleForm.typeId">
						<el-option
							v-for="(item, index) in typeSelect"
							:key="index"
							:label="item.label"
							:value="item.id"
						></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="bioName" label="作物名称">
					<el-input
						v-model="ruleForm.bioName"
						placeholder="请输入作物名称"
						maxlength="10"
					></el-input>
				</el-form-item>
				<el-form-item label="农事内容">
					<el-input
						v-model="ruleForm.content"
						type="textarea"
						placeholder="请输入农事内容"
						rows="8"
						maxlength="150"
						show-word-limit
					></el-input>
				</el-form-item>
				<el-form-item class="form-item-btns" style="padding-right: 40px">
					<el-button class="btn btn-confirm" @click="onSubmit">保存</el-button>
					<el-button class="btn btn-cancel" @click="onClose">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
	</el-dialog>
</template>

<script>
/**
 * @description 生产管理页面表格的新增和编辑弹出层
 */
const defaultForm = {
	orgId: '',
	typeId: '',
	bioName: '',
	content: '',
}
export default {
	data() {
		return {
			visible: false, // 弹窗是否显示
			diaType: '', // 弹窗类型-新增/编辑
			titles: '', // title
			orgSelects: [], // 区域下拉选
			typeSelect: [], // 农事类型下拉选
			// 表单传参数据
			ruleForm: Object.assign({}, defaultForm),
			// 表单校验规则
			rules: {
				orgId: [
					{
						required: true,
						message: '请选择区域',
						trigger: 'blur',
					},
				],
				typeId: [
					{
						required: true,
						message: '请选择农事类型',
						trigger: 'blur',
					},
				],
				bioName: [
					{
						required: true,
						message: '请输入作物名称',
						trigger: 'blur',
					},
				],
			},
		}
	},
	mounted() {
		// 获取区域下拉选数据
		if (this.orgSelects && this.orgSelects.length) return
		this.getOrgCode()
	},
	methods: {
		// 获取区域下拉选数据
		getOrgCode() {
      let userInfo = JSON.parse(window.localStorage.getItem('wlwUserInfo'));
			let params = {
				orgId: userInfo['orgId'],
			}
			this.$http
				.getAction(this.$api.findFarmingByOrgCode, params)
				.then((res) => {
					console.log('llllll')
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelects = datas || []
					} else {
						this.orgSelects = []
					}
				})
				.catch(() => {
					this.orgSelects = []
				})
		},
		set(val) {
			this.typeSelect = val
		},
		// 点击新增
		add() {
			this.ruleForm = Object.assign({}, defaultForm)
			this.diaType = 'add'

			this.visible = true
		},
		// 编辑
		edit(rows) {
			this.diaType = 'edit'
			this.visible = true
			this.$nextTick(() => {
				this.$refs.ruleForm.resetFields()
				this.ruleForm = Object.assign({}, rows)
				let orgIndex = this.orgSelects.findIndex((item) => {
					return item.orgName == rows.orgName
				})
				this.$set(this.ruleForm, 'orgId', this.orgSelects[orgIndex]['id'])
			})
		},
		// 点击保存
		onSubmit() {
			// 规则校验
			this.$refs['ruleForm'].validate((valid) => {
				console.log(this.ruleForm)
				if (valid) {
					this.$http
						.postAction(this.$api.productionSave, this.ruleForm)
						.then((res) => {
							if (res.meta.success) {
								// 请求保存/新增接口
								if (this.diaType == 'add') {
									this.$message('新增成功', 'success')
								} else {
									this.$message('编辑成功', 'success')
								}
								// 发送事件进行列表的重新请求
								this.$emit('updataList')
								setTimeout(() => {
									this.onClose()
								}, 200)
							} else {
								this.$message('操作失败，请稍后重试', 'error')
							}
						})
						.catch(() => {
							this.$message('操作失败，请稍后重试', 'error')
						})
				} else {
					console.log('error submit!!')
					return false
				}
			})
		},
		// 弹窗关闭
		onClose() {
			this.visible = false
		},
	},
}
</script>

<style lang="scss">
// 弹出框的样式
.table-dialog {
	&.el-dialog {
		width: 5.95rem;
		text-align: left;
		box-shadow: 0px 1px 13px 0px rgba(114, 114, 114, 0.4);
		border-radius: 6px;
	}
	// 头部
	.el-dialog__header {
		width: 5.84rem;
		margin: 0 auto;
		padding: 0.23rem 0.31rem;
		font-size: 0.17rem;
		color: #333333;
		border-bottom: 1px solid #f1f1f1;
	}
	.el-dialog__headerbtn {
		font-size: 0.33rem;
		color: #454545;
		.el-dialog__close {
			&:hover {
				color: #333333;
			}
		}
	}
	// 内容
	.el-dialog__body {
		padding: 0.33rem 0.38rem 1rem;
	}
	.el-form-item {
		margin-bottom: 0.19rem;
	}
	.el-form-item__error {
		padding-top: 0;
	}
	.el-form-item__label {
		font-size: 0.17rem;
		color: #454545;
		line-height: 0.45rem;
	}
	.el-form-item__content {
		width: 4.16rem;
		line-height: 0.45rem;
		.el-input__inner {
			height: 0.45rem;
			line-height: 0.45rem;
			color: #454545;
			font-size: 0.17rem;
			&::-webkit-input-placeholder {
				color: #999999;
			}
			&::-ms-input-placeholder {
				color: #999999;
			}
			&::placeholder {
				color: #999999;
			}
		}
		.el-textarea__inner {
			color: #454545;
			font-size: 0.17rem;
			&::-webkit-input-placeholder {
				color: #999999;
				font-size: 0.17rem;
			}
			&::-ms-input-placeholder {
				color: #999999;
				font-size: 0.17rem;
			}
			&::placeholder {
				color: #999999;
				font-size: 0.17rem;
			}
		}
		.el-select {
			width: 100%;
		}
	}
	.form-item-btns {
		margin-top: 0.53rem;
		.el-form-item__content {
			margin-left: 0.5rem !important;
			display: flex;
			justify-content: space-around;
		}
	}
	.btn {
		width: 1.5rem;
		height: 0.45rem;
		border-radius: 3px;
		padding: 0;
		text-align: center;
		line-height: 0.45rem;
	}
	.btn-cancel {
		border: 1px solid #f1f1f1;

		padding: 0;
		width: 1.5rem;
		height: 0.45rem;

		color: #999999;
		&:hover {
			background-color: #ffffff;
			border-color: #dedcdc;
			color: #8d8d8d;
		}
	}
	.btn-confirm {
		border: none;
		background-color: #2daea9;
		color: #ffffff;
		&:hover {
			background-color: #2daea9;
			color: #ffffff;
		}
	}
}
</style>
